import { getActiveElements, getScribeById } from 'JS/sagas/selectors';
import { takeEvery, select, put } from 'redux-saga/effects';
import cloneDeep from 'lodash.clonedeep';
import { EDITOR_KEYBOARD_DELETE, EDITOR_COPY } from 'JS/actionCreators/editorActions';
import { deleteActiveElement, deleteSelectedScenes, updateClipboardPayload } from 'JS/actionCreators/scribeActions';
import canDeleteScenes from 'JS/shared/helpers/canDeleteScenes';

import createSceneClipboardPayload from './sagaHelpers/createSceneClipboardPayload';

const KEYBOARD_TRIGGER = 'Keyboard';

function* handleKeyboardDelete({ scribeId }) {
  // Determine if we are dealing with scene or elements or nothing and fire off the appropriate action
  const scribe = yield select(getScribeById, scribeId);
  const { selectedSceneIds, activeElements } = yield select(state => state.scribes);
  const hasNoActiveSelection = !selectedSceneIds.length && !activeElements.length;
  if (hasNoActiveSelection) {
    return;
  }

  const isScenesAction = !!selectedSceneIds.length;

  if (isScenesAction) {
    if (canDeleteScenes(scribe, selectedSceneIds)) {
      yield put(deleteSelectedScenes(scribeId, KEYBOARD_TRIGGER));
    }
  } else {
    yield put(deleteActiveElement(scribeId));
  }
}

function* handleEditorCopy({ scribeId, asCut = false }) {
  const scribe = yield select(getScribeById, scribeId);
  const activeScene = scribe.scenes.find(scene => scene.active);
  const activeElementIds = yield select(getActiveElements);
  const selectedSceneIds = yield select(state => state.scribes.selectedSceneIds);

  const hasScenesSelected = !!selectedSceneIds.length;
  const hasElementsSelected = !!activeElementIds.length;

  if (!scribe || (!hasScenesSelected && !hasElementsSelected)) return;

  if (hasScenesSelected) {
    const clipboardPayload = createSceneClipboardPayload(scribe, selectedSceneIds);
    yield put(updateClipboardPayload(clipboardPayload));
  } else {
    const elementClones = activeElementIds.map(elementId => {
      const clone = cloneDeep(scribe.elements.find(el => el.id === elementId));
      delete clone.id;
      return clone;
    });

    const clipboardPayload = {
      type: 'element',
      metadata: {
        sceneId: activeScene.id,
        wasCut: asCut
      },
      data: elementClones
    };

    yield put(updateClipboardPayload(clipboardPayload));
  }
}

export default function* editorSagas() {
  yield takeEvery(EDITOR_KEYBOARD_DELETE, handleKeyboardDelete);
  yield takeEvery(EDITOR_COPY, handleEditorCopy);
}
